import { render, staticRenderFns } from "./ProvinceModal.vue?vue&type=template&id=4de469f0&"
import script from "./ProvinceModal.vue?vue&type=script&lang=js&"
export * from "./ProvinceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports